const style = {
  emailBodyPreviewText: {
    color: '#616161 !important',
    maxHeight: '125px',
    wordBreak: 'break-word'
  }
}

export default style
